// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"455":"9c15319f","569":"f5dd2833"}[chunkId] + ".chunk.css";
};